import { render, staticRenderFns } from "./AddSubscribe.vue?vue&type=template&id=b4012010&"
import script from "./AddSubscribe.vue?vue&type=script&lang=js&"
export * from "./AddSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./AddSubscribe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports